import React from 'react'
import './StatisticPreview.scss'

const StatisticPreview = ({ actionsTitle }) => {
    return (
        <div className={`statistic-preview${actionsTitle ? ' withMoves' : ''}`}>
            {actionsTitle ? (
                <div>
                    <span className="statistic-preview__title">{actionsTitle}:</span>
                    <span>0</span>
                </div>
            ) : null}
            <div>
                <div className="statistic-preview__timer">00:00</div>
            </div>
        </div>
    )
}

export default StatisticPreview
